import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {RelatedEntitiesWidgetState} from "./models/related-entities-widget.state";
import {RelatedEntitiesWidgetConfig} from "./related-entities-widget.config";

export class RelatedEntitiesWidgetStore extends BaseMobxStore {
  static injectables = [RelatedEntitiesWidgetConfig, RelatedEntitiesWidgetState];
}
